import { BasePage, BasePageURL } from "@/constants/site-builder";

export enum CallToActionBasePageType {
  Agenda = "AGENDA_LINK",
  Attendees = "ATTENDEES",
  Awards = "AWARDS",
  BookNow = "BUY_LINK",
  Contacts = "CONTACT",
  DownloadableAgenda = "DOWNLOADABLE_AGENDA",
  Highlights = "HIGHLIGHTS",
  Home = "HOME_LINK",
  HotelMap = "HOTEL_MAP",
  MediaPartners = "MEDIA_PARTNERS",
  Networking = "NETWORKING",
  News = "NEWS",
  Partnering = "PARTNERING",
  PlanYourVisit = "PLAN_YOUR_VISIT",
  RegisterVisit = "REGISTER_VISIT",
  Search = "SEARCH",
  Speakers = "SPEAKERS_LINK",
  Sponsors = "SPONSORS_OPPORTUNITIES_LINK",
  Trainers = "TRAINERS_LINK",
  VipServices = "VIP_SERVICES",
}

export const CallToActionBasePageURL: Readonly<
  Record<CallToActionBasePageType, string>
> = {
  [CallToActionBasePageType.Agenda]: "agenda",
  [CallToActionBasePageType.Attendees]: "attendees",
  [CallToActionBasePageType.Awards]: "awards",
  [CallToActionBasePageType.BookNow]: "purchase/select-package",
  [CallToActionBasePageType.Contacts]: "contact",
  [CallToActionBasePageType.DownloadableAgenda]: "agenda/download",
  [CallToActionBasePageType.Highlights]: "highlights",
  [CallToActionBasePageType.Home]: BasePageURL[BasePage.Home],
  [CallToActionBasePageType.HotelMap]: BasePageURL[BasePage.HotelMap],
  [CallToActionBasePageType.MediaPartners]: "media-partners",
  [CallToActionBasePageType.Networking]: "networking",
  [CallToActionBasePageType.News]: "news-insights",
  [CallToActionBasePageType.Partnering]: "partnering",
  [CallToActionBasePageType.PlanYourVisit]: "plan-your-visit",
  [CallToActionBasePageType.RegisterVisit]: "register-visit",
  [CallToActionBasePageType.Search]: "search",
  [CallToActionBasePageType.Speakers]: BasePageURL[BasePage.Speakers],
  [CallToActionBasePageType.Sponsors]: BasePageURL[BasePage.Sponsors],
  [CallToActionBasePageType.Trainers]: "trainers",
  [CallToActionBasePageType.VipServices]: "vip-services",
};

export enum CallToActionType {
  Landing = "LANDING",
  Custom = "CUSTOM",
}

export enum CallToActionSelectType {
  None = "NONE",
  BasePage = "BASE",
  LandingPage = "LANDING",
  Custom = "CUSTOM",
}
